import {i18n} from '~/i18n';

export const DEFAULT_PASSING_SCORE_PERCENTAGE = '80';
/*
*
* {
        label: i18n('settings.use-question-pool'),
        type: 'bool',
        name: 'settings.useQuestionPool',
      },
      {
        type: 'bool',
        label: i18n('settings.randomize-questions'),
        name: 'settings.randomizeQuestions',
      },
      {
        label: i18n('settings.use-stars'),
        type: 'bool',
        name: 'settings.useStart',
      },
      {
        name: 'settings.stars',
        type: 'input',
        label: i18n('settings.course-stars'),
        variant: 'number',
      },
             {
        type: 'separator',
      },

      {
        type: 'separator',
        label: i18n('settings.language'),
      },
      {
        type: 'input',
        label: i18n('settings.language'),
        name: 'settings.language',
      },
* */

export const courseSettings = [
  {
    description: 'generalDescription',
    name: 'general',
    settings: [
      {
        type: 'input',
        name: 'descriptionpage.title',
        intlPlaceholder: 'course-name-placeholder',
        label: i18n('toolbar.title'),
      },
      {
        name: 'descriptionpage.description',
        label: i18n('toolbar.description'),
        placeholder: i18n('placeholder.description'),
        multiline: true,
        type: 'htmltext',
      },
      {type: 'separator'},
      {
        type: 'select',
        options: Object.entries(i18n('settings.course-scaling')).map(([value, text]) => ({
          value,
          label: text,
        })),
        label: i18n('settings.view'),
        name: 'settings.courseSize',
      },
    ],
  },
  {
    description: 'assessments-description',
    name: 'assessments',
    settings: [
    /* disabled for now because of some bugs
      {
        label: i18n('settings.speed-course'),
        type: 'bool-speed',
        // getValue: () => speedCourseEnabled,
        // setValue: () => {
        //   dispatch(switchSpeedCourse());
        // },
        name: 'settings.speed.disabled',
      }, */
      {
        label: i18n('settings.result-page'),
        type: 'bool',
        name: 'resultpage.disabled',
        forceValue: ({fieldData = {}}) => fieldData['settings.passingCriteriaEnabled'] === true ? false : undefined,
        disabled: ({fieldData = {}}) => fieldData['settings.passingCriteriaEnabled'] === true,
      },
      {
        label: i18n('settings.inform-about-answer'),
        type: 'bool',
        name: 'settings.informAnswer',
      },
      {
        label: i18n('settings.hide-feedback-card'),
        type: 'bool',
        name: 'settings.hideFeedbackCard',
      },
      {
        label: i18n('settings.set-passing-criteria'),
        type: 'bool',
        name: 'settings.passingCriteriaEnabled',
      },
      {
        label: i18n('settings.passing-score-percentage-required'),
        type: 'input',
        name: 'settings.passingScore',
        defaultValue: DEFAULT_PASSING_SCORE_PERCENTAGE,
        inputWidth: '4.6em',
        layout: 'row',
        small: true,
        marginLeft: '1em',
        visible: ({fieldData = {}}) => fieldData['settings.passingCriteriaEnabled'] === true,
      },
    ],
  },
  {
    description: 'stylingDescription',
    name: 'styling',
    settings: [
      {
        name: 'defaultTheme',
        label: i18n('settings.default-theme'),
        type: 'defaultTheme',
      },
      {
        name: 'defaultFont',
        label: i18n('settings.default-font'),
        type: 'defaultFont',
      },
      {
        name: 'defaultFontTitle',
        label: i18n('settings.default-font-title'),
        type: 'defaultFontTitle',
      },
      {
        name: 'settings.cssUrl',
        label: i18n('settings.extra-css-page'),
        placeholder: 'https://',
        type: 'input',
        variant: 'url',
      },
    ],
  },
];
